module.exports = __webpack_public_path__ + "img/A_ezplan3.d3504fb4.png";